export default __webpack_public_path__ + "static/media/img_job_03.8e90d867.jpg";